import React from "react";
import {SDialogFC, SDialogProps} from "@/Master/SDialogFC/SDialogFC";
import {useDialogMethods} from "@/Master/SDialogFC/useDialogMethods";
import styles from "./select.module.css";
import RedeemSelectItem from "@/app/(redeem)/redeemSelect/RedeemSelectItem";
import ScrollableContainer from "@/app/_components/ScrollableContainer/ScrollableContainer";
import Util from "@/Master/Util";
import {RedeemManager} from "@/Core/Redeem/RedeemManager";
import BigTips from "@/Master/BigTips";
import {SDialogManagerFC} from "@/Master/SDialogFC/SDialogManagerFC";
import {RedeemAccountDialogFC} from "@/app/(redeem)/redeemAccount/RedeemAccountDialogFC";
import {RedeemCashOutDialogFC} from "@/app/(redeem)/redeemCashOut/RedeemCashOutDialogFC";
import {hideForceLoading, showForceLoading} from "@/app/_dialogs/LoadingForceDialog/LoadingForceDialogFC";

interface RedeemSelectDialogProps extends SDialogProps {
    channelList: ResponseRedeemConfigData[],
    onItemClick?: (data: ResponseRedeemConfigData) => void
}

export const RedeemSelectDialogFC: React.FC<RedeemSelectDialogProps> = (props) => {
    const {fcKey, onClose, channelList,onItemClick} = props;
    const {closeDialog} = useDialogMethods(fcKey);
    const onCloseDialog = () => {
        closeDialog();
        onClose?.();
    }

    const onBtnItemClick = async (channelData: ResponseRedeemConfigData) => {
        if (Util.isLog) {
            console.log('onCallItemClick', channelData);
        }
        const {channelType} = channelData;
        showForceLoading()
        const redeemCheckData = await RedeemManager.GetRedeemCheckAsync(channelType);
        if (redeemCheckData == null){
            hideForceLoading();
            BigTips.showMsg('GetRedeemCheckAsync  = null');
            return;
        }

        const {isWithdraw, withdrawAccount} = redeemCheckData;
        if (isWithdraw){
            hideForceLoading();
            //提示。已有提现订单。去历史记录页面查看
            BigTips.showMsg('There is a withdrawal order. Go to the history page to view');
            return;
        }
        const isRedeemAccountOk = withdrawAccount != null && withdrawAccount.length > 0;
        if (!isRedeemAccountOk){
            hideForceLoading();
            closeDialog();
            //没有绑定帐号。去绑定帐号页面
            SDialogManagerFC.openDialog(RedeemAccountDialogFC, {
                fcKey: SDialogManagerFC.getFCKey(RedeemAccountDialogFC),
                channelData:channelData,
                channelCheckData:redeemCheckData,
                onClose: (isOk: boolean) => {
                    closeDialog();
                }
            });
            return;
        }
        hideForceLoading();
        //直接进入提现输入页面
        SDialogManagerFC.openDialog(RedeemCashOutDialogFC, {
            fcKey: SDialogManagerFC.getFCKey(RedeemCashOutDialogFC),
            channelData:channelData,
            channelCheckData:redeemCheckData,
            onClose: (isOk: boolean) => {
            }
        });
        onItemClick?.(channelData);
        onCloseDialog();
    }

    return (
        <SDialogFC
            fcKey={fcKey}
            onClose={onClose}
            mode="CenterBottom"
            title={<span style={{fontSize: '0.56rem'}}>Choose Redemption Method</span>}
        >
            <ScrollableContainer>
                <section className={styles.list}>
                    {channelList && channelList.length > 0 ? (channelList.map((row) =>
                        <RedeemSelectItem data={row} key={row.channelType} callClick={onBtnItemClick}/>
                    )):(
                        <section>No withdrawal channels</section>
                    )}
                </section>
            </ScrollableContainer>
        </SDialogFC>
    );
};
